import React from 'react';
import { GATOR_BACKUP_PLANS, HIGHLIGHT_ID, PLAN_CYCLE_TYPES } from '@/pages/GatorBackup/GatorBackupHandler/GatorBackup.enum';
import { COUNTRY } from '@/config';

const priceSymbols = {
  mx: 'MX$',
  co: 'COP$',
  cl: 'CLP$',
  ar: 'AR$',
  pe: 'S/',
  do: 'RD$',
  ec: 'US$',
  uy: 'UYU$',
  bo: 'Bs',
};
const priceSymbolText = priceSymbols[COUNTRY.toLowerCase()];

export default {
  title: (
    <>
      Sin Backup, un error puede borrar
      {' '}
      <span>tu sitio!</span>
    </>
  ),
  description: 'Protege tu negocio contra fallas, ataques y errores humanos. Activa el backup automático y nunca más dejes de vender. Tu sitio siempre online.',
  highlights: [
    {
      id: HIGHLIGHT_ID.BACKUP_AUTO,
      title: 'Backup automático',
      description: 'Tu sitio es guardado solo. Si algo sale mal, ¡no pierdes nada!',
    },
    {
      id: HIGHLIGHT_ID.BACKUP_CLOUD,
      title: 'Backup en la nube en 1 clic',
      description: 'Recupera el sitio completo o solo un archivo con un clic.',
    },
    {
      id: HIGHLIGHT_ID.BACKUP_ALERT,
      title: 'Avisos de cambios y amenazas',
      description: 'Recibe alertas y acompaña las modificaciones antes de que se conviertan en un problema.',
    },
  ],
  domain: {
    label: 'Selecciona o escribe tu dominio',
    toggleLabel: 'Escribir otro dominio',
    placeholder: 'Dominio',
    textFieldPlaceholder: 'Escribe tu dominio ej: ”miodominio.com”',
    errorMessage: 'Formato inválido. Escribe solo el nombre del dominio (ej: miodominio.com)',
  },
  plan: {
    label: 'Elige el plan de Backup para tu sitio',
    options: {
      [PLAN_CYCLE_TYPES.ANNUALLY]: '1 año',
      [PLAN_CYCLE_TYPES.SEMIANNUALLY]: '6 meses',
      [PLAN_CYCLE_TYPES.QUARTERLY]: '3 meses',
      [PLAN_CYCLE_TYPES.MONTHLY]: '1 mes',
    },
  },
  tablePlans: {
    badge: 'Recomendado',
    advantages: 'Ventajas:',
    priceSymbol: priceSymbolText,
    priceSuffix: '/mes*',
    pricePerCycle: {
      [PLAN_CYCLE_TYPES.ANNUALLY]: price => `${price} por 1 año `,
      [PLAN_CYCLE_TYPES.SEMIANNUALLY]: price => `${price} por 6 meses`,
      [PLAN_CYCLE_TYPES.QUARTERLY]: price => `${price} por 3 meses`,
    },
    ctaTitleValidation: 'Selecciona tu dominio antes de elegir el plan de backup.',
    options: {
      [GATOR_BACKUP_PLANS.CORE]: {
        name: 'Plano Core',
        cta: 'Quiero el Core',
        highlights: [
          (
            <React.Fragment key="1">
              <b>1 GB</b>
              {' '}
              de almacenamiento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>5 sitios</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup diario',
          'Retención de backup ilimitada',
          'Copias de seguridad incrementales',
          'Restaurar el sitio completo con un clic',
          'Backup de base de datos',
          'Notificaciones de cambios (muestra historial y envía correo cuando el sitio es modificado)',
          'Restauración selectiva (a nivel de archivo)',
          'Descargar Backup',
        ],
      },
      [GATOR_BACKUP_PLANS.PLUS]: {
        name: 'Plano Plus',
        cta: 'Quiero el Plus',
        highlights: [
          (
            <React.Fragment key="1">
              <b>5 GB</b>
              {' '}
              de almacenamiento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>10 sitios</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup diario',
          'Retención de backup ilimitada',
          'Copias de seguridad incrementales',
          'Restaurar el sitio completo con un clic',
          'Backup de base de datos',
          'Notificaciones de cambios (muestra historial y envía correo cuando el sitio es modificado)',
          'Restauración selectiva (a nivel de archivo)',
          'Descargar Backup',
          'Copias de seguridad manuales cuando quieras',
          'Filas prioritarias',
        ],
      },
      [GATOR_BACKUP_PLANS.ADVANCED]: {
        name: 'Plano Advanced',
        cta: 'Quiero el Advanced',
        highlights: [
          (
            <React.Fragment key="1">
              <b>10 GB</b>
              {' '}
              de almacenamiento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>25 sitios</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup diario',
          'Retención de backup ilimitada',
          'Copias de seguridad incrementales',
          'Restaurar el sitio completo con un clic',
          'Backup de base de datos',
          'Notificaciones de cambios (muestra historial y envía correo cuando el sitio es modificado)',
          'Restauración selectiva (a nivel de archivo)',
          'Descargar Backup',
          'Copias de seguridad manuales cuando quieras',
          'Filas prioritarias',
        ],
      },
      [GATOR_BACKUP_PLANS.MAX]: {
        name: 'Plano Max',
        cta: 'Quiero el Max',
        highlights: [
          (
            <React.Fragment key="1">
              <b>25 GB</b>
              {' '}
              de almacenamiento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>100 sitios</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup diario',
          'Retención de backup ilimitada',
          'Copias de seguridad incrementales',
          'Restaurar el sitio completo con un clic',
          'Backup de base de datos',
          'Notificaciones de cambios (muestra historial y envía correo cuando el sitio es modificado)',
          'Restauración selectiva (a nivel de archivo)',
          'Descargar Backup',
          'Copias de seguridad manuales cuando quieras',
          'Filas prioritarias',
        ],
      },
    },
  },
};
